// import components
import type { TextFieldProps, BoxProps, DividerProps } from '@mui/material';
import { styled, Box, TextField, Divider } from '@mui/material';

export const StyledPlanUnitSelectorBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isToolbar'
})<BoxProps & { isToolbar?: boolean }>(({ theme, isToolbar }) => ({
  display: 'flex',
  alignItems: isToolbar ? 'center' : 'flex-end',

  '.MuiAutocomplete-root': {
    minWidth: theme.spacing(75),

    '.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon': {
      padding: 0
    },

    '.MuiInput-root.MuiInput-underline.input-box': {
      display: 'flex',
      justifyContent: 'space-between',
      padding: isToolbar ? theme.spacing(0, 1.5) : theme.spacing(0.5, 1.5, 0.5),

      input: {
        marginRight: theme.spacing(1)
      }
    },

    '.add-more': {
      visibility: 'hidden',
      padding: theme.spacing(1)
    },

    '&:hover .add-more': {
      visibility: 'visible'
    },

    '.MuiChip-root': {
      margin: theme.spacing(0, 1, 0),
      backgroundColor: 'unset',
      height: 'auto',
      border: 0,

      '.MuiChip-label': {
        paddingLeft: 0
      }
    },

    '.MuiAutocomplete-tag': {
      height: 'auto'
    },

    '.invalid': {
      color: theme.palette.error.main,

      input: {
        color: theme.palette.error.main
      }
    }
  },

  '&.full-width .MuiAutocomplete-root': {
    minWidth: 'auto'
  },

  ...(isToolbar && {
    marginLeft: theme.spacing(-2),
    '.MuiFormControl-root': {
      padding: 0
    },

    'label.MuiFormLabel-root': {
      top: theme.spacing(-2.5),
      left: theme.spacing(3)
    },

    'label.MuiFormLabel-root.Mui-focused, label.MuiFormLabel-filled, label[data-shrink="true"]':
      {
        display: 'none'
      },

    '& .MuiInputBase-root.MuiInput-root.MuiInput-underline::before, .MuiInputBase-root.MuiInput-root.MuiInput-underline::after':
      {
        borderBottom: 'none'
      },

    '& span.MuiAutocomplete-tag': {
      paddingLeft: theme.spacing(2)
    },

    '& .MuiAutocomplete-inputRoot': {
      height: '34px'
    }
  })
}));

export const StyledCustomTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'isToolbar'
})<TextFieldProps & { isToolbar?: boolean }>(({ theme, isToolbar }) => ({
  ...(isToolbar && {
    border: 'none',
    padding: theme.spacing(1),

    '& .MuiInputBase-root.MuiInput-root.MuiInput-underline': {
      padding: 0,
      marginTop: 0
    },

    '& .MuiInputBase-root:hover': {
      backgroundColor: theme.palette.action.hover,
      borderRadius: '12px'
    },

    '& .MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: 'none'
    },

    '& .input-box::before, & .input-box::after': {
      borderBottom: 'none'
    },

    '.MuiInput-root.MuiInputBase-sizeSmall .MuiInput-input': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  })
}));

export const StyledToolbarDivider = styled(Divider)<DividerProps>(
  ({ theme }) => ({
    marginLeft: theme.spacing(2)
  })
);
